<template>
  <div class="ValidationModale_Container">
    <div class="ValidationModale">
      <p class="text">{{ text }}</p>
      <div class="ValidationModale__Footer">
        <CTA
          class="ValidationModale__Btn"
          :label="$t('yes').toUpperCase()"
          @clickButton="close(true)"
        />
        <CTA
          class="ValidationModale__Btn"
          :label="$t('no').toUpperCase()"
          @clickButton="close(false)"
          outline
        />
      </div>
    </div>
  </div>
</template>

<script>
import { animOpacity } from '@/utils/animations.js'
import CTA from '@/components/button/CTA'

export default {
  name: 'validation-modale',
  components: {
    CTA
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    wording () {
      return this.$store.getters['langs/wording']
    }
  },
  mounted () {
    this.open()
  },
  beforeDestroy () {},
  methods: {
    open () {
      animOpacity('.ValidationModale_Container', 0.5, 0, 1)
    },
    close (validate) {
      animOpacity('.ValidationModale_Container', 0.5, 1, 0, () =>
        this.$emit('closeValidModale', validate)
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../styles/main.scss';

.ValidationModale_Container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  box-sizing: border-box;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  @media only screen and (max-height: 700px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  @media only screen and (max-width: 500px) {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.ValidationModale {
  position: relative;
  box-sizing: border-box;
  padding: 1rem 2rem;
  width: 406px;
  height: 184px;
  border-radius: 30px;
  background-color: white;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  @media only screen and (max-height: 700px) {
    height: 100%;
    width: 400px;
    padding: 0 2rem;
  }
  @media only screen and (max-width: 500px) {
    width: 100%;
    padding: 0 2rem;
  }
}

.text {
  padding: 0 10%;
  line-height: 150%;
  text-align: center;
  font-family: 'Gotham Bold';
  @include fluid-type($min_width, $max_width, $min_font * 1.2, $max_font * 1);
}

.ValidationModale__Footer {
  height: 25%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ValidationModale__Btn {
  height: 100%;
  width: 48%;
}
</style>
